import React from "react";
import { Card, Form } from "react-bootstrap";

export default function ProductPermissions(props) {
  const {
    isCustomerFirstOrder,
    setIsCustomerFirstOrder,
    isCustomerSecondOrder,
    setIsCustomerSecondOrder,
    customerCantSee,
    setCustomerCantSee,
    isHalfPortion,
    setIsHalfPortion,
  } = props;
  return (
    <div>
      <Card className="mb-3">
        <Card.Body>
          {/* QR Menu Section */}
          <fieldset
            style={{
              padding: "15px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              marginBottom: "15px",
              backgroundColor: "#f9f9f9",
            }}
          >
            <legend
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                marginBottom: "10px",
                padding: "0 10px",
                color: "#555",
              }}
            >
              QR Menü İzinleri
            </legend>

            <Form.Group className="mb-2">
              <Form.Check
                type="checkbox"
                label="Müşteri QR sayfasında ana ekranda görsün"
                value={isCustomerFirstOrder}
                checked={isCustomerFirstOrder}
                onChange={(e) => {
                  setIsCustomerFirstOrder(e.target.checked);
                  setCustomerCantSee(false);
                  if (e.target.checked && isCustomerSecondOrder) {
                    setIsCustomerSecondOrder(false);
                  }
                }}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Check
                type="checkbox"
                label="Müşteri QR sayfasında ana ekranda GÖRMESİN!"
                value={isCustomerSecondOrder}
                checked={isCustomerSecondOrder}
                onChange={(e) => {
                  setIsCustomerSecondOrder(e.target.checked);
                  setCustomerCantSee(false);
                  if (e.target.checked && isCustomerFirstOrder) {
                    setIsCustomerFirstOrder(false);
                  }
                }}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Check
                type="checkbox"
                label="Müşteri bu ürünü QR sayfasında hiçbiryerde görmesin"
                value={customerCantSee}
                checked={customerCantSee}
                onChange={(e) => {
                  setCustomerCantSee(e.target.checked);
                  setIsCustomerFirstOrder(false);
                  setIsCustomerSecondOrder(false);
                }}
              />
            </Form.Group>
          </fieldset>

          {/* Other Settings Section */}
          <fieldset
            style={{
              padding: "15px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
            }}
          >
            <legend
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                marginBottom: "10px",
                padding: "0 10px",
                color: "#555",
              }}
            >
              Diğer İzinler
            </legend>

            <Form.Group className="mb-2">
              <Form.Check
                type="checkbox"
                label="Yarım porsiyon olabilir"
                value={isHalfPortion}
                checked={isHalfPortion}
                onChange={(e) => {
                  setIsHalfPortion(e.target.checked);
                }}
              />
            </Form.Group>
          </fieldset>
        </Card.Body>
      </Card>
    </div>
  );
}
